import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const ProtectedForVisiteur: React.FC = () => {
  const { id } = useParams<{ id: string }>(); 
  const allowedVisiteur = localStorage.getItem("VisiteurId"); 

  if (allowedVisiteur) {
  return <Outlet />; 

  }

  return <Navigate to="/erreur" replace />;


};

export default ProtectedForVisiteur;